import { useTranslation } from "react-i18next";
import { styled, useTheme } from "@mui/material";
import { Button } from "components";

const TerminationWrapper = styled("div")({
  alignSelf: "center",
  margin: "auto",
  "& .header": {
    "& h1": {
      fontSize: "20px",
      margin: "20px",
      textAlign: "center",
      fontWeight: "normal",
    },
  },
  "& .buttons": {
    display: " flex",
    flexDirection: "column",
    "& .button": {
      width: "60%",
      marginTop: "10px",
      alignSelf: "center",
    },
  },
});

const ChatbotTerminateUnstyled = ({ onConfirm, onReject, className }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <TerminationWrapper className={className}>
      <div className="header">
        <h1>{t("Chatbot.ClosingMessage.Message")}</h1>
      </div>
      <div className="buttons">
        <Button
          variant="filled"
          corners="square"
          className="button"
          sx={{
            backgroundColor: theme.navbarColors.background,
            "&:hover": { backgroundColor: "#223E45" },
          }}
          onClick={onConfirm}
        >
          {t("Chatbot.ClosingMessage.Yes")}
        </Button>
        <Button
          corners="square"
          className="button"
          sx={{
            color: theme.navbarColors.background,
            borderColor: theme.navbarColors.background,
          }}
          onClick={onReject}
        >
          {t("Chatbot.ClosingMessage.No")}
        </Button>
      </div>
    </TerminationWrapper>
  );
};

const ChatbotTerminate = styled(ChatbotTerminateUnstyled)({});

export default ChatbotTerminate;
